import clsx from 'clsx';

function WdPageSimpleHeader(props) {
  return (
    <div className={clsx('WdPageSimple-header', props.className)}>
      <div className="container">{props.header && props.header}</div>
    </div>
  );
}

export default WdPageSimpleHeader;
